import React from 'react';
import '../styles/Breadcrumbs.css';
import { MdChevronRight } from 'react-icons/md';

const Breadcrumbs = ({ values = [] }) => {
    const breadcrumbItems = ['Home', ...values];

    return (
        <div className='breadcrumbs_main'>
            {breadcrumbItems.map((value, index) => (
                <>
                    <span key={index}>
                        {value}
                    </span>
                    {index < breadcrumbItems.length - 1 && <MdChevronRight />}
                </>
            ))}
        </div>
    )
}

export default Breadcrumbs;